/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-16 08:39:30
 *
 *******************************************************/
//flow
import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';
import {
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST,
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS,
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE,
  GET_EXP_REVIEW_RATING_STATUS_REQUEST,
  GET_EXP_REVIEW_RATING_STATUS_SUCCESS,
  GET_EXP_REVIEW_RATING_STATUS_FAILURE,
  RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK
} from 'stores/flow-type/exp-review-rating.type';

/**
 * Submit feedback after installation
 * @return {object} The RSAA object for API middleware
 */
export const sendReviewRatingFeedback = (body: Object, i18n: I18n) => {
  return apiService.sendRequest('admin-v3.experimental-features.send-rating-feedback', { body }, [
    EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST,
    {
      type: EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS,
      payload: async (action, state, res) => {
        const result = await processRes(
          res,
          'custom',
          i18n.translate('AdminHTML.Common.SupportTicketActions.sendSupportTicket_Success'),
          i18n
        );
        return { ...result, rating: body.rating };
      }
    },
    {
      type: EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'custom',
          i18n.translate('AdminHTML.Common.SupportTicketActions.sendSupportTicket_Failure'),
          i18n
        )
    }
  ]);
};

/**
 * Get review rating status of tenant
 * @return {object} The RSAA object for API middleware
 */
export const getReviewRatingStatus = () => {
  return apiService.sendRequest('admin-v3.experimental-features.get-rating-status', {}, [
    GET_EXP_REVIEW_RATING_STATUS_REQUEST,
    {
      type: GET_EXP_REVIEW_RATING_STATUS_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: GET_EXP_REVIEW_RATING_STATUS_FAILURE,
      payload: () => {}
    }
  ]);
};

/**
 * Reset setup feedback state
 * @return {object} The RSAA object for API middleware
 */
export const resetReviewRatingFeedback = () => {
  return {
    type: RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK,
    payload: {}
  };
};
